/** PURE_IMPORTS_START .._operators_retry PURE_IMPORTS_END */
import { retry as higherOrder } from '../operators/retry';
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */
export function retry(count) {
    if (count === void 0) {
        count = -1;
    }
    return higherOrder(count)(this);
}
//# sourceMappingURL=retry.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/operator/retry.js
// module id = 847
// module chunks = 0